import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import type { IApiEnvelope, IEnvelopeClient } from './api-envelope.types';

export interface ProductDimensionInputDto {
  height: number;
  width: number;
  depth: number;
  quantity: number;
}

export interface ProductDimensionDto extends ProductDimensionInputDto {
  _id: string;
  devOrderId: string;
  cbmRequired: number;
  cftRequired: number;
}

export interface ProductDimensionErrorDto {
  invalidFields?: string[];
}

const api = apiClient as unknown as IEnvelopeClient;

const byDevOrder = (devOrderId: string): string => `${apiEndpoint}${API.PRODUCT_DIMENSION.BY_DEV_ORDER.replace(':devOrderId', devOrderId)}`;

export const getProductDimensionService = (devOrderId: string): Promise<IApiEnvelope<ProductDimensionDto | null>> =>
  api.get<ProductDimensionDto | null>(byDevOrder(devOrderId));

export const saveProductDimensionService = (
  devOrderId: string,
  body: ProductDimensionInputDto,
): Promise<IApiEnvelope<ProductDimensionDto | ProductDimensionErrorDto>> =>
  api.put<ProductDimensionDto | ProductDimensionErrorDto>(byDevOrder(devOrderId), body);
